(function(window, document) {
  'use strict';

  mint.on('documentLoaded', function() {
    const newsHerostage = document.querySelector('.dm-event .container--herostage');
    const pageContentHeader = document.querySelector('.page-content--header');

    if(newsHerostage !== null) {
      newsHerostage.querySelector('img').classList.add('herostage__object');

      pageContentHeader.appendChild(newsHerostage);
      pageContentHeader.classList.add('page-content--header-filled');
    }
  });
})(window, document);
